import { captureException } from '@sentry/react'
import { HttpError } from 'app/rest'

export function shareTelegram(url: string, text?: string) {
  const query = new URLSearchParams(text ? { url, text } : { url })
  window.open(`https://t.me/share/url?${query}`)
}

export function getTelegramIdFromMiniApp(initData: string): string | undefined {
  try {
    if (!initData) {
      return undefined
    }

    const params = new URLSearchParams(initData)
    const userStr = params.get('user')

    if (!userStr) {
      return undefined
    }

    const user = JSON.parse(userStr)
    return user?.id?.toString()
  } catch (e) {
    captureException(e)
    throw new HttpError(500, 'Failed to get telegram_id from Mini App initData')
  }
}
